module.exports = "<div class=\"js-popout-region native-grid__popout\"></div> <div class=\"js-native-grid-header-region native-grid__header\"></div> <div class=\"js-native-grid-list-region native-grid__list\"></div> <div class=js-nocolumns-view-region></div> ";


//////////////////
// WEBPACK FOOTER
// ../src/nativeGrid/templates/nativeGrid.hbs
// module id = 714
// module chunks = 0